export const useColors = () => {
    return {
        white: "[;#ffffff;]",
        purple: "[b;#cd5ff8;]",
        green: "[b;#4fd559;]"
    };

}